const EDITABLE_SELECTOR = 'input,textarea,select,[contenteditable="true"],[role="textbox"]';
const BLOCKING_SELECTOR =
  '[role="dialog"],[aria-modal="true"],dialog[open],.fixed.inset-0,[aria-busy="true"],[data-feedback-block]';

function visible(node) {
  if (node.closest('[hidden],[aria-hidden="true"]')) return false;
  const style = getComputedStyle(node);
  return style.display !== 'none' && style.visibility !== 'hidden';
}

export function feedbackContextBusy() {
  if (document.visibilityState === 'hidden') return true;
  if (document.activeElement?.closest(EDITABLE_SELECTOR)) return true;
  return [...document.querySelectorAll(BLOCKING_SELECTOR)].some(visible);
}
